<template>
  <div :class="['card-button', `p-${padding}`, classes]">
    <slot>
      <div v-if="isOnlyText">
        <p class="text-small text-neutral-clear">
          {{ text }}
        </p>
      </div>

      <MEInfoBlock
        v-else
        :title="title"
        :text="text"
        :tag="tag"
        :icon-size="iconSize"
        :icon-name="iconName"
        vertical-alignment="center"
      />
    </slot>

    <transition name="fade">
      <ion-icon v-if="selected" class="icon text-normal text-primary absolute top-2 right-2" name="checkmark-circle" />
    </transition>
  </div>
</template>

<script>
import MEInfoBlock from 'commons/js/components/atoms/MEInfoBlock';

export default {
  name: 'card-button',

  components: {
    MEInfoBlock,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    padding: {
      type: String,
      default: '4',
    },
    iconSize: {
      type: Number,
      default: 48,
    },
    iconName: {
      type: String,
      default: '',
    },
    shadowless: {
			type: Boolean,
			default: false,
		},
    selected: {
			type: Boolean,
			default: false,
		}
  },

  computed: {
    classes() {
      return {
        'card-button--simple': this.isOnlyText,
        'card-button--shadowless': this.shadowless,
        'card-button--selected': this.selected,
      }
    },

    isOnlyText() {
			return !this.title && !this.iconName && this.text;
		},
  },
};
</script>

<style lang="stylus" scoped>
  .card-button
    background white
    width 100%
    position relative
    cursor pointer
    border 1px solid
    border-color transparent
    border-radius 4px
    box-shadow 0px 2px 5px alpha(#26303c, 0.15)
    transition all .25s

    &:hover
    &--selected
      box-shadow none
      border-color #00519d

    &--simple
      display flex
      align-items center
      justify-content center
      padding 24px
      text-align center

    &--shadowless
      box-shadow none
      border 1px solid #c8cdda
</style>
